import React from 'react';
import { Box, Paper, Stack, Tooltip, Typography } from '@mui/material';
import InfoOutlined from '@mui/icons-material/InfoOutlined';

interface SectionCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  /** Explains the non-obvious mechanic behind the section (tiering formula, timing signals, etc). */
  infoTooltip?: string;
  children: React.ReactNode;
}

/** Consistent shell for each Build-2 demo section: icon + title + info icon + body. */
export default function SectionCard({ icon, title, description, infoTooltip, children }: SectionCardProps) {
  return (
    <Paper
      elevation={0}
      sx={(t) => ({
        p: 2.5,
        borderRadius: `${t.ds.radius.md}px`,
        border: `1px solid ${t.tokens.border.subtle}`,
      })}
    >
      <Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap" useFlexGap sx={{ mb: 0.5 }}>
        {icon}
        <Typography variant="subtitle1" fontWeight={700}>
          {title}
        </Typography>
        {infoTooltip ? (
          <Tooltip title={infoTooltip} arrow placement="top">
            <InfoOutlined sx={{ fontSize: 15, color: 'text.disabled', cursor: 'help' }} />
          </Tooltip>
        ) : null}
      </Stack>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2, lineHeight: 1.55, maxWidth: 780 }}>
        {description}
      </Typography>
      <Box>{children}</Box>
    </Paper>
  );
}
